/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="m12.0006 14.7496 11.4705 7.1707c.5269.3294.687 1.0236.3578 1.5506-.3058.4894-.9261.6625-1.435.4211l-.1152-.0632-10.2798-6.4263-10.2784 6.4177c-.4895.3054-1.1228.1886-1.474-.2519l-.0759-.1073c-.3053-.4896-.1885-1.1231.2518-1.4744l.1073-.0759 11.4709-7.1611Zm0-7.3748 11.4705 7.1707c.5269.3294.687 1.0236.3578 1.5506-.3058.4894-.9261.6625-1.435.4211l-.1152-.0632-10.2798-6.4263-10.2784 6.4177c-.4895.3054-1.1228.1886-1.474-.2519l-.0759-.1073c-.3053-.4896-.1885-1.1231.2518-1.4744l.1073-.0759 11.4709-7.1611Zm0-7.3748 11.4705 7.1707c.5269.3294.687 1.0236.3578 1.5506-.3058.4894-.9261.6625-1.435.421l-.1152-.063-10.2798-6.4264L1.7205 9.0706c-.4895.3054-1.1228.1886-1.474-.2519l-.0759-.1073c-.3053-.4896-.1885-1.1231.2518-1.4744l.1073-.076L12.0006 0Z"
  />,
  'MenuTraffic'
);
